import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { subscribeToRoster } from '@db/studentService';
import type { Student } from '@types-local/class.types';

const MEDALS = ['🥇', '🥈', '🥉'];

export default function StudentLeaderboard(): React.ReactElement {
  const [students, setStudents] = useState<Student[]>([]);
  const classId = sessionStorage.getItem('gh_class_id') ?? '';

  useEffect(() => {
    if (!classId) return;
    return subscribeToRoster(classId, setStudents);
  }, [classId]);

  return (
    <div className="min-h-screen p-4 max-w-lg mx-auto">
      <div className="text-center py-6">
        <h1 className="text-2xl font-black gradient-text">🏆 Leaderboard</h1>
      </div>
      <div className="space-y-2">
        {students.map((s, i) => (
          <motion.div key={s.id} layout initial={{ opacity: 0, x: -12 }} animate={{ opacity: 1, x: 0 }}
            transition={{ delay: i * 0.04 }}
            className="flex items-center gap-3 glass rounded-2xl px-4 py-3">
            <span className="text-lg w-6 text-center">{i < 3 ? MEDALS[i] : `${i + 1}`}</span>
            <span className="text-2xl">{s.avatar}</span>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-bold text-slate-900 truncate">{s.name}</p>
              <p className="text-xs text-slate-500">Level {s.level} · ⭐ {s.totalStars}</p>
            </div>
            <span className="text-sm font-bold text-brand-300">{s.xp} XP</span>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
